//http://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser

// return the browser name.
function browser(){
	var ua= navigator.userAgent, tem, 
		M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	
	if(/trident/i.test(M[1])){
		tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
		return ['IE', (tem[1] || '') ];
	}
	
	if(M[1]=== 'Chrome'){
		tem= ua.match(/\bOPR\/(\d+)/)
		if(tem!= null) return 'Opera '+tem[1];
	}
	
	M= M[2]? [M[1], M[2]]: [navigator.appName.toLowerCase(), navigator.appVersion, '-?'];
	if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
	
	M[0] = M[0].toLowerCase();

	return M;
}

module.exports = browser;


/** WEBPACK FOOTER **
 ** ./src/js/helpers/browser.js
 **/